import React, { useState } from 'react';
import { Menu, X, Phone, Instagram } from 'lucide-react';
import { contactInfo } from '../data/mock';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const whatsappUrl = `https://wa.me/${contactInfo.whatsapp.replace(/\D/g, '')}?text=${encodeURIComponent(contactInfo.whatsappMessage)}`;

  const TikTokIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
      <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-5.2 1.74 2.89 2.89 0 012.31-4.64 2.93 2.93 0 01.88.13V9.4a6.84 6.84 0 00-.88-.05A6.33 6.33 0 005 20.1a6.34 6.34 0 0010.86-4.43v-7a8.16 8.16 0 004.77 1.52v-3.4a4.85 4.85 0 01-1-.1z"/>
    </svg>
  );

  const navigationItems = [
    { label: 'Inicio', href: '#home' },
    { label: 'Servicios', href: '#services' },
    { label: 'Acerca de', href: '#about' },
    { label: 'Galería', href: '#gallery' },
    { label: 'Consejos', href: '#tips' },
    { label: 'Contacto', href: '#contact' }
  ];

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <header className="header-nav">
      <div className="container flex items-center justify-between gap-4">
        {/* Logo */}
        <div className="flex flex-col flex-shrink-0 min-w-0">
          <div className="text-base sm:text-lg md:text-xl text-primary truncate" style={{ fontFamily: "'Space Grotesk', sans-serif", fontWeight: 600 }}>
            Dr. Adrián Cuéllar Barboza
          </div>
          <div className="text-xs sm:text-sm text-secondary truncate" style={{ fontFamily: "'Space Grotesk', sans-serif", fontWeight: 400 }}>
            Dermatólogo certificado
          </div>
        </div>

        {/* Desktop Navigation */}
        <nav className="hidden lg:flex items-center gap-4 xl:gap-6">
          {navigationItems.map((item, index) => (
            <button
              key={index}
              onClick={() => scrollToSection(item.href)}
              className="text-secondary hover:text-primary transition-colors duration-200 font-medium text-sm whitespace-nowrap"
            >
              {item.label}
            </button>
          ))}
        </nav>

        {/* Desktop CTA and Social */}
        <div className="hidden lg:flex items-center gap-2 xl:gap-4 flex-shrink-0">
          <div className="flex items-center gap-2 xl:gap-3">
            <a href="https://www.instagram.com/adrian.cuellar.derma/" target="_blank" rel="noopener noreferrer">
              <Instagram size={18} className="text-secondary hover:text-accent-purple-400 transition-colors cursor-pointer" />
            </a>
            <a href="https://www.tiktok.com/@adrian.cuellar.derma" target="_blank" rel="noopener noreferrer">
              <div className="text-secondary hover:text-accent-purple-400 transition-colors cursor-pointer">
                <TikTokIcon />
              </div>
            </a>
          </div>
          <div className="hidden xl:flex items-center gap-2 text-secondary text-sm">
            <Phone size={14} />
            <span className="font-mono whitespace-nowrap">{contactInfo.phone}</span>
          </div>
          <a href={whatsappUrl} className="btn-primary text-sm px-3 xl:px-4 py-2 whitespace-nowrap">
            Agendar
          </a>
        </div>

        {/* Tablet/Mobile CTA (hidden on mobile, visible on md) */}
        <div className="hidden md:flex lg:hidden items-center gap-2">
          <a href={whatsappUrl} className="btn-primary text-sm px-3 py-2 whitespace-nowrap">
            Cita
          </a>
        </div>

        {/* Mobile Menu Button */}
        <button
          className="lg:hidden btn-nav flex-shrink-0"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="lg:hidden absolute top-full left-0 right-0 bg-overlay backdrop-blur-md border-t border-light">
          <nav className="container py-4">
            <div className="flex flex-col gap-4">
              {navigationItems.map((item, index) => (
                <button
                  key={index}
                  onClick={() => scrollToSection(item.href)}
                  className="text-left text-secondary hover:text-primary transition-colors duration-200 py-2"
                >
                  {item.label}
                </button>
              ))}
              
              {/* Social Media in Mobile */}
              <div className="flex items-center gap-4 py-2">
                <span className="text-sm text-secondary">Síguenos:</span>
                <a href="https://www.instagram.com/adrian.cuellar.derma/" target="_blank" rel="noopener noreferrer">
                  <Instagram size={18} className="text-secondary hover:text-accent-purple-400 transition-colors" />
                </a>
                <a href="https://www.tiktok.com/@adrian.cuellar.derma" target="_blank" rel="noopener noreferrer">
                  <div className="text-secondary hover:text-accent-purple-400 transition-colors">
                    <TikTokIcon />
                  </div>
                </a>
              </div>
              
              <div className="flex items-center gap-2 text-secondary py-2">
                <Phone size={16} />
                <span className="font-mono text-sm">{contactInfo.phone}</span>
              </div>
              <a href={whatsappUrl} className="btn-primary w-full mt-2 text-center block">
                Agendar Cita
              </a>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;